import { apiForgot } from '../../../../common/api/email-identity'

const sendForgotEmail = email => ({
  requestPrefix: 'FORGOT_PASSWORD:SEND_EMAIL',
  request: () => apiForgot(email)
})

const refreshForgotPassword = () => ({
  type: 'FORGOT_PASSWORD:REFRESH'
})

export { sendForgotEmail, refreshForgotPassword }
